var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcfStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2479 85.0009H39.7511M80.2511 85.0009H79.7495",
    stroke: "#719A5D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9991 30V49.9992M40.0007 30V49.9992",
    stroke: "#719A5D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 15.0001C59.9999 13.6742 59.4732 12.4026 58.5357 11.4651C57.5982 10.5276 56.3266 10.0009 55.0007 10.0009H25.0007C24.344 10.0005 23.6937 10.1296 23.0869 10.3807C22.4801 10.6318 21.9287 11 21.4642 11.4642C20.9998 11.9285 20.6313 12.4797 20.3799 13.0864C20.1285 13.6931 19.9991 14.3433 19.9991 15.0001V105C19.9991 105.657 20.1285 106.307 20.3799 106.914C20.6313 107.52 20.9998 108.072 21.4642 108.536C21.9287 109 22.4801 109.368 23.0869 109.619C23.6937 109.87 24.344 110 25.0007 109.999H55.0007C56.3266 109.999 57.5982 109.473 58.5357 108.535C59.4732 107.597 59.9999 106.326 59.9999 105M59.9999 15.0001V105M59.9999 15.0001C59.9999 13.6742 60.5266 12.4026 61.4642 11.4651C62.4017 10.5276 63.6733 10.0009 64.9991 10.0009H94.9991C95.6559 10.0005 96.3062 10.1296 96.913 10.3807C97.5198 10.6318 98.0712 11 98.5357 11.4642C99.0001 11.9285 99.3686 12.4797 99.62 13.0864C99.8714 13.6931 100.001 14.3433 100.001 15.0001V105C100.001 105.657 99.8714 106.307 99.62 106.914C99.3686 107.52 99.0001 108.072 98.5357 108.536C98.0712 109 97.5198 109.368 96.913 109.619C96.3062 109.87 95.6559 110 94.9991 109.999H64.9991C63.6733 109.999 62.4017 109.473 61.4642 108.535C60.5266 107.597 59.9999 106.326 59.9999 105",
    stroke: "#0D5F4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcfStep2);
export default __webpack_public_path__ + "static/media/PCFStep2.1f434b3b837dcb1d7a97638b57236da7.svg";
export { ForwardRef as ReactComponent };